import './App.css';
import Home from './pages/index';
import HomeNew from './pages/index_new_slider';
import Projects from './pages/project';
import Careers from './pages/careers';
import Services from './pages/services';
import Location from './pages/location';
import Downloads from './pages/downloads';
import Contact from './pages/contact';
import About from './pages/about-us';
import ProjectDetails from './pages/project-details';
import PrivacyPolicy from './pages/privacy-policy';
import CookiesPolicy from './pages/cookies';
import CodeOfConduct from './pages/code-of-conduct';
import CareersDetail from './pages/careers-detail';
import CookiesConsentModal from './pages/modal/CookiesConsentModal';


import { HelmetProvider } from 'react-helmet-async';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <CookiesConsentModal />
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            {/* Redirect root URL to /Home */}
            <Route path="/" element={<Home />} />

            {/* Optional: redirect /Home to root */}
            <Route path="/Home" element={<Navigate to="/" replace />} />

            <Route path="/HomeNew" element={<HomeNew />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/Careers" element={<Careers />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Location" element={<Location />} />
            <Route path="/Downloads" element={<Downloads />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/About" element={<About />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/CookiesPolicy" element={<CookiesPolicy />} />
            <Route path="/CodeOfConduct" element={<CodeOfConduct />} />
            <Route path="/careers-details/:slug" element={<CareersDetail />} />
            <Route path="/project-details/:slug" element={<ProjectDetails />} />

          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
